












































































import {Component, Prop, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import {RoleStore} from "@/modules/roles/store";
import {assignValueToForm} from "@/shared/services/helper/utils";
import FreightServiceSelector from "@/shared/components/FreightServiceSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import UploadDocument from "@/shared/components/UploadDocument/Index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Role} from "@/interfaces/entity";

const form = {
    id: undefined,
    name: undefined,
    permissionIds: [],
    status: undefined,
    postOfficeRowGuid: undefined
};

const columns = [
    {
        title: "Chức năng",
        dataIndex: "name",
        key: "name"
    },
    {
        title: "Quyền hạn",
        dataIndex: "permissions",
        key: "permissions",
        scopedSlots: { customRender: 'permissions' },
    }
];

@Component({
    name: "RoleForm",
    components: {
        PostOfficeSelector,
        UploadDocument,
        EnumSelector,
        FreightServiceSelector, MillisecondDatePicker, WardSelector, DistrictSelector, ProvinceSelector}
})
export default class extends mixins(CommonMixin) {
    @Prop()
    readonly id!: number;

    CommonStatus = CommonStatus;
    
    form = {...form};
    columns = columns;

    private rules = {
        name: [{ required: true, message: "Nhập tên nhóm quyền", trigger: "change" }],
        permissionIds: [{ required: true, message: "Chọn quyền", trigger: "change" }],
    };

    get functionPermissions() {
        return RoleStore.functionPermissions;
    }
    async created() {
        await RoleStore.listFunctionPermission();
        if (this.id) {
            try {
                const data: Role = await RoleStore.singleRole(this.id);
                this.form = assignValueToForm(this.form, {...data, permissionIds: data.permissions.map((item) => item.id)});
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }

    private onSubmit() {
        (this.$refs.formRole as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                this.id
                    ? await RoleStore.updateRole(this.form)
                    : await RoleStore.createRole(this.form);
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} nhóm quyền thành công`
                });
                this.$router.push({ name: "listRole" });
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || `${this.id ? 'Tạo' : 'Sửa'} nhóm quyền thất bại`}`
                })
            }
        })
    }
}
